import { render, staticRenderFns } from "./swiperNav.vue?vue&type=template&id=8ffbceb0&"
import script from "./swiperNav.vue?vue&type=script&lang=js&"
export * from "./swiperNav.vue?vue&type=script&lang=js&"
import style0 from "./swiperNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports